import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-party-gold bg-party-ink" data-id="element-115" data-mp="ddvgdgeskhf3">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-116" data-mp="icorx3aipycm">
        <p className="font-sans text-[0.62rem] font-bold uppercase tracking-[0.14em] text-party-gold" data-id="element-117" data-mp="me203k132dmp">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-1.5 font-display text-lg font-extrabold leading-tight text-white sm:text-2xl" data-id="element-118" data-mp="wczjk8jnjgyu">
          Comienza hoy desde cero y avanza a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-xl border-4 border-dashed border-party-gold bg-white text-party-ink" data-id="element-119" data-mp="2y3umrlg6uifl">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block" data-id="element-120" data-mp="12oa7mstdk3i6">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-121" data-mp="xw0b2txr856x" />
          </a>
          <div className="p-3" data-id="element-122" data-mp="ox52jb78mj0g">
            <p className="font-sans text-[0.8rem] font-extrabold uppercase leading-tight text-party-rose sm:text-sm" data-id="element-123" data-mp="oxybmito5klr">
              {PRODUCT_NAME}
            </p>
            <p className="mt-0.5 font-display text-lg font-black" data-id="element-124" data-mp="1gocm052h4eso">
              6 Tomos + 5 Bonos
            </p>
            <p className="text-[0.75rem] text-party-ink/75" data-id="element-125" data-mp="1ckdc45bp8e8a">
              🎁 Bonos valorados en{' '}
              <span className="font-semibold text-party-rose line-through" data-id="element-126" data-mp="17m3c9hf14pgc">
                {BONUS_VALUE}
              </span>
            </p>

            <p className="mt-1.5 inline-block rounded bg-party-rose px-2.5 py-0.5 font-sans text-[0.62rem] font-extrabold uppercase tracking-wide text-white" data-id="element-127" data-mp="3scu3c28hj3sc">
              🔥 Oferta especial
            </p>

            <p className="mt-1 font-display text-5xl font-black leading-none text-party-rose sm:text-6xl" data-id="element-128" data-mp="2ng760yhr8c6">
              Hoy: {PRICE}
            </p>
            <p className="mt-1 text-[0.7rem] font-semibold text-party-ink/75" data-id="element-129" data-mp="3ksrsnnjsh7sj">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-130" data-mp="3b2zwiow1k6ly">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>

            <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-semibold text-party-ink/75" data-id="element-131" data-mp="3fw1ghbb3uwce">
              <span className="flex items-center gap-1" data-id="element-132" data-mp="363ncsd0gvfnl">
                <ZapIcon size={12} className="text-party-rose" data-id="element-133" data-mp="3622fwgqojkmk" />
                Acceso Inmediato
              </span>
              <span className="text-party-ink/40" data-id="element-134" data-mp="2x3h2f002evsn">•</span>
              <span className="flex items-center gap-1" data-id="element-135" data-mp="2x2xixeurnzci">
                <ShieldCheckIcon size={12} className="text-party-brown" data-id="element-136" data-mp="2dhf91tgiyba6" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}